import request from '@/request'

/* 1.73.3 得到商品列表 */
export const getList = data => {
  return request({
    url: '/inf_CollectiveProduct_Vipwd/getList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
/* 1.73.4 得到商品详情 */
export const getDetail = data => {
  return request({
    url: '/inf_CollectiveProduct_Vipwd/getDetail.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 1.73.5 得到拼团列表
export const getGroupList = data => {
  return request({
    url: '/inf_CollectiveGroup_Vipwd/getList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 1.73.6 下单
export const addOrder = data => {
  return request({
    url: '/inf_CollectiveOrder_Vipwd/addOrder.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getMyList = data => {
  return request({
    url: '/inf_CollectiveOrder_Vipwd/getList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getOrderDetail = data => {
  return request({
    url: '/inf_CollectiveOrder_Vipwd/getDetail.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getTelephone = data => {
  return request({
    url: '/inf_CollectiveStore_Vipwd/getTelephone.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getGroupShare = data => {
  return request({
    url: '/inf_CollectiveGroup_Vipwd/getGroupShare.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getGroupStatus = data => {
  return request({
    url: '/inf_CollectiveGroup_Vipwd/getGroupStatus.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const completeOrder = data => {
  return request({
    url: '/inf_CollectiveOrder_Vipwd/completeOrder.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
